import { render } from "./UISection.vue?vue&type=template&id=a573b8ea"
import script from "./UISection.vue?vue&type=script&lang=js"
export * from "./UISection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__